// extracted by mini-css-extract-plugin
export default {"body":"Main_body__0WywB","main":"Main_main__bSred","additional_filtering":"Main_additional_filtering__z5IJ-"};